interface Preventable<T = any> {
  target: T;
  preventDefault: () => void;
  stopPropagation?: () => void;
}

export function targetWithDefaultPrevented<TTarget = any, T = void>(func: (target: TTarget) => T) {
  return (e: Preventable<TTarget>) => {
    e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    func(e.target);
  }
}

export function withDefaultPrevented<T = void>(func: () => T) {
  return (e: Preventable) => {
    e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    func();
  }
}

export function isOverflown(query) {
  const element = document.querySelector(query);
  if(!element) return;
  const { clientWidth, scrollWidth } = element;
  return  scrollWidth > clientWidth;
}

const searchParams = new URLSearchParams(window.location.hash.split('?')[1])
export function searchQuery(param){
  return searchParams?.get(param);
};